import { styled, theme } from "@theme/stitches.config"

export const IconWrapper = styled("div", {
    display: "flex",
    alignItems: "center",
    "& svg, & img": {
        width: 16
    },
    variants: {
        icon: {
            left: {
                "& svg, & img": {
                    mr: 13
                }
            },
            right: {
                "& svg, & img": {
                    ml: 13
                }
            },
            loading: {
                "& svg, & img": {
                    ml: 13
                }
            }
        }
    }
})

export const PlainButton = styled("button", {
    color: theme.colors.white,
    appearance: "none",
    cursor: "pointer",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    border: "3px solid transparent",
    borderRadius: 4,
    p: "10px 41px",
    fontSize: theme.fontSizes.desktopH6,
    textDecoration: "none",
    fontFamily: theme.fonts.heading,
    lineHeight: 1.2,
    transition: "all 200ms ease",
    outline: "none",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    variants: {
        color: {
            red: {
                backgroundColor: theme.colors.R600,
                "&:hover": {
                    backgroundColor: "black"
                }
            },
            grey: {
                backgroundColor: theme.colors.N900,
                "&:hover": {
                    backgroundColor: theme.colors.R600
                }
            }
        },
        outlined: {
            true: {
                borderColor: theme.colors.R500,
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: theme.colors.R600
                }
            }
        }
    },
    compoundVariants: [
        {
            color: theme.colors.R500,
            outlined: true,
            css: {
                backgroundColor: "transparent"
            }
        }
    ],
    "@mdDown": {
        fontSizePxToRem: 16
    }
})

export const IconButton = styled(PlainButton, {
    width: 20,
    height: 20,
    padding: 10,
    borderRadius: "50%",
    "& svg, & img": {
        width: 10,
        height: 10
    }
})
